/* mypka-historieslider.js — myPKA, 01.09.2026 (Felix)
 * Elternticket 869eqz47g — Kundin-Call 01.09.: die Ueber-uns-Historie
 * (description-grid, 6 Timeline-Karten 2018 … Heute) soll mobil ein
 * durchswipebares Element sein statt eines Stapels.
 *
 * WAS: Unterhalb 750 px wird die Kartenliste der Sektionsinstanz `historie`
 * (templates/page.ueber-uns.json) ein Swiper mit einer Karte je Ansicht und
 * Punktleiste. Gemessen vorher bei 390 px: 6 Karten gestapelt, 2478 px hoch.
 *
 * BAUFORM = mypka-quizslider.js (28.08.2026), bewusst dieselbe:
 * - NUR im mobilen Zweig gebaut — oberhalb 749 px laeuft `aufbauen` nie, der
 *   Desktop ist KONSTRUKTIV unveraendert, nicht bloss geprueft.
 * - sections/description-grid.liquid wird NICHT angefasst: die Sektion rendert
 *   auch page.about.json und zwei verwaiste Produktvorlagen.
 * - Swiper statt Scroll-Snap: das Theme laedt Swiper 8.4.3 global und bedient
 *   damit jeden anderen Slider; Klassen werden ERGAENZT, nicht ersetzt.
 * - Punktleiste `type: 'custom'` mit `mypka-punkt`-Markup, damit die
 *   Trefferflaechen-Latte (24 px, WCAG 2.2 SC 2.5.8) und die
 *   Tastaturbedienung aus mypka-slider-tastatur.js daran haengen.
 * - Layout-Umschaltung (grid -> flex) steht spezifitaetshoeher in
 *   assets/mypka-mobil.css, Abschnitt 10 — Begruendung dort.
 *
 * REICHWEITE — gemessen am 01.09.2026, nicht angenommen:
 * description-grid rendert live NUR auf /pages/uber-uns (Sektionsinstanz
 * `historie`). page.about.json haengt an keiner Seite (pages-Query: kein
 * templateSuffix `about`), product.adventskalender/.produkt.json an keinem
 * Produkt. Der Selektor bindet trotzdem an die INSTANZ (`[id$="__historie"]`),
 * nicht an den Sektionstyp: eine kuenftige zweite description-grid-Seite
 * bekommt den Slider nicht stillschweigend mit.
 *
 * ABWEICHUNG VOM QUIZSLIDER — INLINE-STYLES DER KARTEN:
 * Jede Karte traegt aus der Sektion ein eigenes style-Attribut
 * (`grid-column-start/end`, sections/description-grid.liquid). Im Flex-Kontext
 * des Sliders sind die grid-*-Angaben wirkungslos (sie gelten nur fuer
 * Grid-Items), aber Swiper schreibt eigene Inline-Styles dazu und der Abbau
 * des Quizsliders (`removeAttribute('style')`) wuerde hier die
 * SEKTIONS-Styles mit wegwerfen. Deshalb: Original-Attribut vor dem Aufbau
 * je Karte merken und beim Abbau wortgleich zuruecksetzen. Ein iPhone quer
 * (844 px) liegt oberhalb des Umschaltpunkts — der Abbau ist Normalfall.
 *
 * ABSTAND: `spaceBetween: 16` = die 1.6rem `gap` des Kartenrasters
 * (section-descriptions-grid.css). Im Slider-CSS steht `gap: 0`, weil Swiper 8
 * den Abstand als margin-right setzt und ein Flex-gap in seiner
 * Breitenrechnung nicht vorkommt (Begruendung im Quizslider, Z. 51 ff.).
 */
(() => {
	const UMSCHALTPUNKT = 749;
	const ABSTAND = 16;
	const abfrage = window.matchMedia(`(max-width: ${UMSCHALTPUNKT}px)`);

	/* Nachfahren- statt Kindkombinator: nach dem Aufbau liegt die Buehne
	 * zwischen Sektion und Liste — sonst faende der Abbau seine Liste nicht. */
	const listen = (wurzel) =>
		[...(wurzel || document).querySelectorAll(
			'.shopify-section[id$="__historie"] .cards-grid__wrapper'
		)].filter((el) => el.querySelectorAll(':scope > .cards-grid__item').length >= 2);

	const punkteRendern = (current, total) => {
		let out = '';
		for (let i = 1; i <= total; i += 1) {
			const aktiv = i === current ? ' swiper-pagination-bullet-active' : '';
			out += `<span class="swiper-pagination-bullet mypka-punkt${aktiv}" tabindex="0" role="button" aria-label="Gehe zu Station ${i} von ${total}"><span class="mypka-punkt__kern"></span></span>`;
		}
		return out;
	};

	const aufbauen = (liste) => {
		if (liste.dataset.mypkaHistorieslider === 'an') return;
		if (typeof Swiper === 'undefined') return;
		const karten = [...liste.querySelectorAll(':scope > .cards-grid__item')];
		if (karten.length < 2) return;

		const buehne = document.createElement('div');
		buehne.className = 'swiper mypka-historieslider';
		liste.parentNode.insertBefore(buehne, liste);
		buehne.appendChild(liste);

		const punkte = document.createElement('div');
		punkte.className = 'swiper-pagination mypka-historieslider__punkte';
		buehne.insertAdjacentElement('afterend', punkte);

		liste.classList.add('swiper-wrapper');
		karten.forEach((karte) => {
			/* Original-Inline-Styles der Sektion sichern (grid-column-*), bevor
			 * Swiper eigene dazuschreibt — der Abbau setzt sie wortgleich
			 * zurueck. `??` statt `||`: auch ein leeres Attribut bleibt leer. */
			karte.dataset.mypkaStyleOriginal = karte.getAttribute('style') ?? '';
			karte.classList.add('swiper-slide');
		});

		liste.mypkaTeile = { buehne, punkte };
		liste.mypkaSwiper = new Swiper(buehne, {
			/* slidesPerView 1, KEIN Anschnitt — dieselbe Messlage wie beim
			 * Quizslider (dort 28.08. gegen Veras 1.06 gemessen: der Bruchteil
			 * wird von spaceBetween aufgefressen, bei 320 px bleibt nichts
			 * sichtbar). Wer hier einen Anschnitt will, misst 390 UND 320 nach. */
			slidesPerView: 1,
			spaceBetween: ABSTAND,
			loop: false,
			speed: 400,
			/* Die Karten sind <div> in einem <div>-Raster, keine Liste — Swipers
			 * Vorgabe role="group" mit Beschriftung ist hier die richtige
			 * Semantik (anders als beim Quizslider, dessen Slides <li> sind). */
			a11y: {
				enabled: true,
				slideLabelMessage: 'Station {{index}} von {{slidesLength}}',
				paginationBulletMessage: 'Gehe zu Station {{index}}',
				firstSlideMessage: 'Erste Station',
				lastSlideMessage: 'Letzte Station',
			},
			pagination: {
				el: punkte,
				clickable: true,
				type: 'custom',
				renderCustom: (swiper, current, total) => punkteRendern(current, total),
			},
		});
		liste.dataset.mypkaHistorieslider = 'an';
	};

	const abbauen = (liste) => {
		if (liste.dataset.mypkaHistorieslider !== 'an') return;
		const teile = liste.mypkaTeile || {};
		const buehne = teile.buehne || liste.parentElement;
		const punkte = teile.punkte || null;

		if (liste.mypkaSwiper) {
			liste.mypkaSwiper.destroy(true, true);
			liste.mypkaSwiper = null;
		}
		liste.querySelectorAll(':scope > .cards-grid__item').forEach((karte) => {
			karte.classList.remove('swiper-slide');
			/* Sektions-Styles zurueck statt removeAttribute: siehe Kopfkommentar. */
			if (karte.dataset.mypkaStyleOriginal !== undefined) {
				if (karte.dataset.mypkaStyleOriginal === '') karte.removeAttribute('style');
				else karte.setAttribute('style', karte.dataset.mypkaStyleOriginal);
				delete karte.dataset.mypkaStyleOriginal;
			} else {
				karte.removeAttribute('style');
			}
			karte.removeAttribute('role');
			karte.removeAttribute('aria-label');
		});
		liste.classList.remove('swiper-wrapper');
		liste.removeAttribute('style');
		liste.removeAttribute('aria-live');
		if ((liste.getAttribute('id') || '').startsWith('swiper-wrapper-')) liste.removeAttribute('id');

		if (buehne && buehne.parentNode) {
			buehne.parentNode.insertBefore(liste, buehne);
			buehne.remove();
		}
		if (punkte) punkte.remove();
		delete liste.mypkaTeile;
		delete liste.dataset.mypkaHistorieslider;
	};

	const anwenden = (wurzel) => {
		listen(wurzel).forEach((liste) => (abfrage.matches ? aufbauen(liste) : abbauen(liste)));
	};

	/* `defer` hinter swiper-bundle.min.js: `Swiper` steht, das Markup auch —
	 * Begruendung wie in mypka-quizslider.js, Z. 188 ff. */
	anwenden(document);

	abfrage.addEventListener('change', () => anwenden(document));
	document.addEventListener('shopify:section:load', (event) => anwenden(event.target));
})();
